import { FiatShortCode } from '@fintech-solutions/core';

export const SEND_RECEIVE_SUPPORTED_FIATS = [
  FiatShortCode.EUR,
  FiatShortCode.GBP,
  FiatShortCode.USD,
];